
export type ABGroup = 'A' | 'B';

export class ABTestEngine {
  private readonly COOKIE_NAME = 'ab_test_group';
  private readonly EXPIRY_DAYS = 30;

  private getCookie(name: string): string | null {
    if (typeof document === 'undefined') return null;
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
    return null;
  }

  private setCookie(name: string, value: string, days: number): void {
    if (typeof document === 'undefined') return;
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Lax`;
  }

  private getUrlOverride(): ABGroup | null {
    if (typeof window === 'undefined') return null;
    const params = new URLSearchParams(window.location.search);
    const group = params.get('ab_group')?.toUpperCase();
    if (group === 'A' || group === 'B') return group as ABGroup;
    return null;
  }

  public getOrAssignGroup(): ABGroup {
    // 1. URL 파라미터 오버라이드 확인 (테스트 및 확인용)
    const override = this.getUrlOverride();
    if (override) {
      this.setCookie(this.COOKIE_NAME, override, this.EXPIRY_DAYS);
      this.trackGroup(override);
      return override;
    }

    // 2. 기존 그룹 로드
    let group = this.getCookie(this.COOKIE_NAME) as ABGroup | null;

    // 3. 그룹 배정 (없을 경우 50:50)
    if (!group || (group !== 'A' && group !== 'B')) {
      group = Math.random() < 0.5 ? 'A' : 'B';
      this.setCookie(this.COOKIE_NAME, group, this.EXPIRY_DAYS);
    }

    this.trackGroup(group);
    return group;
  }

  private trackGroup(group: ABGroup): void {
    if (typeof window !== 'undefined' && (window as any).amplitude) {
      const amp = (window as any).amplitude;
      try {
        amp.setUserProperties({ ab_test_group: group });
        amp.track('view_test_page', { ab_test_group: group });
      } catch (e) {
        console.error('Amplitude tracking failed', e);
      }
    }
  }
}

export const abEngine = new ABTestEngine();
